export const productSort = {
    new: "new",
    inexpensive: "inexpensive",
    expensive: "expensive",
    specialOffer: "special_offer",
    bestSelling: "best_selling"
}